<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="''"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_block"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<span>加入库尔</span>&ensp;&ensp;一起改变全球诊断！！
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="top_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">全部职位</div>
						<!-- <div v-if="false" class="right">
							<van-icon name="search" size="20px" style="top: 4px;" />
							<input placeholder="请输入职位关键词" />
							<div class="tit">搜索</div>
						</div> -->
					</div>
					<div v-if="listData.length > 0 && infoData" class="mid_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<div v-for="(value, index) in listData" :key="index" class="list_el" @click="checkInfo(value)">
								<div class="tit">{{ value.title }}</div>
								<div class="txt1">
									<van-icon name="todo-list-o" size="18px" color="#666666" style="top: 3px;" /> {{ value.post_name }} | {{ value.address_name }}
								</div>
								<div class="txt2">
									<van-icon name="clock-o" size="18px" color="#999999" style="top: 3px;" /> 发布时间：<span>{{ value.fabu_time }}</span>
								</div>
							</div>
						</div>
						<div class="right">
							<div class="tit_box">
								<div class="tit">{{ infoData.title }}</div>
								<div class="btn">
									<a style="color: #ffffff;" href="mailto:makuluno1@163.com" target="">申请职位</a>
								</div>
							</div>
							<div class="txt_box">
								<span><van-icon name="todo-list-o" size="18px" color="#999999" style="top: 3px;" /> {{ infoData.post_name }}</span>&ensp;&ensp;&ensp;&ensp;
								<span><van-icon name="location-o" size="18px" color="#999999" style="top: 3px;" /> {{ infoData.address_name }}</span>&ensp;&ensp;&ensp;&ensp;
								<span><van-icon name="clock-o" size="18px" color="#999999" style="top: 3px;" /> 发布时间：<span>{{ infoData.fabu_time }}</span></span>
							</div>
							<div class="tips_box">
								<div>{{ infoData.jingyan }}</div>
								<div>{{ infoData.xueli }}</div>
								<div>招聘人数：{{ infoData.reason_num }}人</div>
							</div>
							<div class="diver"></div>
							<div class="content_box">
								<div class="zz_box">
									<div class="tit">岗位职责</div>
									<div class="txt" v-html="parsedText(infoData.zhize)"></div>
								</div>
								<div class="yq_box">
									<div class="tit">任职要求</div>
									<div class="txt" v-html="parsedText(infoData.yaoqiu)"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="bot_box">
						<div class="left">
							<img src="../../assets/img_public/job/block01.webp" />
						</div>
						<div class="right">
							<img src="../../assets/img_public/job/block02.webp" @click="goCulture" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { jobList, jobInfo } from '@/api/public';  //筛选列表
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			listData: [],
			type: null,
			infoId: null,
		}
	},
	created(){
		let that = this;
		if(that.$route.params.type && that.$route.params.jobInfoId) {
			that.type = that.$route.params.type;
			that.infoId = that.$route.params.jobInfoId.split('.')[0];
			//请求详情
			that.getInfo(that.infoId);
			//请求全部职位列表
			jobList({
				keyword: '',
				address_id: '',
				post_id: '',
				leixing_id: '',
				leixing: that.type == 'social.html' ? 1 : 2,
				page: 1,
				page_size: 999999,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.listData = res.data.data;
			});
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//跳转企业文化
		goCulture() {
			this.$router.push({ path: '/about/culture.html' });
		},
		//处理数据格式
		parsedText(value) {
			return value.replace(/\n/g, "<br>");
		},
		//切换项目
		checkInfo(value) {
			let that = this;
			that.getInfo(value.id);
		},
		//请求详情
		getInfo(value) {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			jobInfo({ id: value }).then(res => {
				that.infoData = res.data;
				that.$toast.clear();
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 80px 0;
		background-color: #F7F6F9;
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			.bot_box{
				display: flex;
				.left{
					flex: 1;
					margin-right: 12px;
					img{
						width: 100%;
					}
				}
				.right{
					flex: 1;
					margin-left: 12px;
					cursor: pointer;
					img{
						width: 100%;
					}
				}
			}
			.mid_box{
				margin: 60px 0;
				display: flex;
				.left{
					flex: 0.3;
					max-height: 1000px;
					overflow-y: auto;
					.list_el{
						margin-bottom: 30px;
						padding: 30px;
						background-color: #ffffff;
						border-radius: 8px;
						cursor: pointer;
						.tit{
							padding-bottom: 6px;
							font-size: 24px;
							border-bottom: 1px solid #F7F6F9;
						}
						.txt1{
							padding: 12px 0 4px 0;
							font-size: 16px;
						}
						.txt2{
							color: #999999;
							font-size: 16px;
							span{
								font-size: 17px;
							}
						}
					}
				}
				.right{
					flex: 0.7;
					max-height: 1000px;
					margin-left: 40px;
					padding: 50px;
					background-color: #ffffff;
					border-radius: 8px;
					overflow: auto;
					.content_box{
						word-break: break-all;
						.zz_box, .yq_box{
							padding-bottom: 50px;
							.tit{
								padding: 10px 0;
								font-size: 18px;
								font-weight: bold;
							}
						}
					}
					.diver{
						height: 1px;
						margin: 40px 0;
						background-color: rgba(0 ,0, 0, 0.1);
					}
					.tips_box{
						div{
							display: inline-block;
							margin-right: 30px;
							padding: 4px 8px;
							border-radius: 6px;
							background-color: #F7F6F9;
							color: #A50073;
						}
					}
					.txt_box{
						padding: 20px 0;
						span{
							font-size: 16px;
							span{
								font-size: 17px;
							}
						}
					}
					.tit_box{
						display: flex;
						align-items: center;
						.tit{
							flex: 1;
							font-size: 30px;
							font-weight: bold;
						}
						.btn{
							width: 200px;
							height: 50px;
							line-height: 50px;
							background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
							border-radius: 8px;
							font-size: 20px;
							color: #ffffff;
							text-align: center;
							cursor: pointer;
						}
					}
				}
			}
			.top_box{
				display: flex;
				align-items: center;
				.right{
					width: auto;
					position: relative;
					padding: 0 30px;
					background-color: #ffffff;
					border: 1px solid #A50073;
					border-radius: 8px;
					input{
						width: 280px;
						height: 48px;
						font-size: 16px;
						color: #A50073;
						border: none;
						padding: 0px 5px;
						user-select: none;
					}
					.tit{
						display: inline-block;
						font-size: 18px;
						cursor: pointer;
						line-height: 1;
						user-select: none;
					}
				}
				.left{
					flex: 1;
					font-size: 24px;
					font-weight: bold;
				}
			}
		}
	}
	.banner_block{
		width: 100%;
		height: 110px;
		line-height: 110px;
		background: linear-gradient( 90deg, #A50073 0%, #C7007E 49%, #A50073 100%);
		text-align: center;
		color: #ffffff;
		font-size: 22px;
		span{
			font-size: 22px;
			font-weight: bold;
		}
	}
}
</style>